import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export interface FigmaEvent {
    type: 'click' | 'transition' | 'start' | 'end' | 'surrender';
    screenId: string;
    screenName?: string;
    x?: number;
    y?: number;
    timestampMs: number;
}

export interface FigmaPathStep {
    screen: string;
    name: string;
}

export interface FigmaTestResult {
    events: Array<FigmaEvent>;
    path: Array<FigmaPathStep>;
    videoFileId?: number | null;
    audioFileId?: number | null;
    cameraFileId?: number | null;
}

export class FigmaTestApi extends QuestionSimpleApi {
    public change(q: QuestionContext, evt: ResponseEventParams): void {
        const { value } = evt;
        const { responseActor, id } = q;
        responseActor.send({ type: 'CHANGE', value, questionId: id });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;

        // value содержит объект с результатом теста (events, path, success, timeMs, finalScreenName, mediaFileIds)
        const result = value as unknown as {
            success: boolean | null;
            timeMs: number;
            finalScreenName: string | null;
            events: Array<FigmaEvent>;
            path: Array<FigmaPathStep>;
            expired?: boolean;
            videoFileId?: number | null;
            audioFileId?: number | null;
            cameraFileId?: number | null;
        } | null;

        if (!result) {
            return {
                question: id,
                data: [],
                comment,
            };
        }

        return {
            question: id,
            data: [
                {
                    bool: result.success,
                    int: result.timeMs,
                    text: result.finalScreenName,
                    expired: result.expired ?? false,
                    json: {
                        events: result.events,
                        path: result.path,
                        videoFileId: result.videoFileId ?? null,
                        audioFileId: result.audioFileId ?? null,
                        cameraFileId: result.cameraFileId ?? null,
                    },
                },
            ],
            comment,
        };
    }

    public validate(question: QuestionContext): boolean {
        const {
            params: { required },
            responseActor,
        } = question;
        const response = responseActor.getSnapshot().context;

        if (!required) {
            return true;
        }

        // Тест считается пройденным, если есть результат (value содержит объект с events)
        const result = response.value as { events?: Array<FigmaEvent> } | null;
        return Boolean(result && result.events && result.events.length > 0);
    }
}
